import { SVGProps } from "react";

export default function LinkedInFilledIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, fill = "#FF6929", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 0H7C3.14 0 0 3.14 0 7V17C0 20.86 3.14 24 7 24H17C20.86 24 24 20.86 24 17V7C24 3.14 20.86 0 17 0ZM8 9.5C7.448 9.5 7 9.948 7 10.5V18C7 18.552 7.448 19 8 19C8.552 19 9 18.552 9 18V10.5C9 9.948 8.552 9.5 8 9.5ZM15 10.5H14C13.649 10.5 13.3135 10.564 13 10.675V10.5C13 9.948 12.552 9.5 12 9.5C11.448 9.5 11 9.948 11 10.5V13.5V18C11 18.552 11.448 19 12 19C12.552 19 13 18.552 13 18V13.5C13 12.9485 13.4485 12.5 14 12.5H15C15.5515 12.5 16 12.9485 16 13.5V18C16 18.552 16.448 19 17 19C17.552 19 18 18.552 18 18V13.5C18 11.8455 16.6545 10.5 15 10.5ZM8 5C7.173 5 6.5 5.673 6.5 6.5C6.5 7.327 7.173 8 8 8C8.827 8 9.5 7.327 9.5 6.5C9.5 5.673 8.827 5 8 5Z"
        fill={fill}
      />
    </svg>
  );
}
